import { Component, QueryList, ViewChildren } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { APPCONFIG } from '../../config';
import { RequestService } from '../requests.service'
import { ErrorHandler } from '../../shared/services/error-handler.service'
import { HttpService } from '../../shared/services/http.service'
import { Http, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { LayoutService } from '../../layout/layout.service'
import { SessionHandler } from '../../shared/services/session-handler.service';
import { CommonService } from '../../shared/services/common.service';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MdAutocomplete, MdAutocompleteTrigger, MdDialog, MdDialogRef } from '@angular/material';
import { dialogComponent } from '../../dialog/dialog.component';
import { FileUploader } from 'ng2-file-upload';
import * as $ from 'jquery';
import { addNewAddressComponent } from '../../trade/details/addNewAddress.component';
import { addNewContactComponent } from '../../trade/details/addNewContact.component';
import { countries } from '../../shared/coutry-data-store';
import { HttpHeaders } from '@angular/common/http';
import { Observable, Subscription } from 'rxjs';
import { startWith, map, debounceTime } from 'rxjs/operators';


@Component({
    selector: 'request-add',
    template: require('./request_add.component.html'),
    styles: [require('./request_add.component.scss')],
    providers: [HttpService, ErrorHandler, SessionHandler, RequestService]
})

export class RequestAddComponent {

    requestCreateForm: FormGroup;
    dialogRef;
    request: any;
    name: any;
    addressList: any;
    contactList: any;
    tradeData: any = {};
    billingData: any = {};
    selectedAddress: any;
    selectedCountry: String = '';
    countryFromID: String = '';
    selectedContactName: any;
    selectedContactEmail: any;
    selectedContactPhone: any;
    palletDisable: boolean = true;
    requestFormData: any = {};
    userData: any;
    requestOrder: any;
    parcels: any;
    id: any;
    selectedParcel: any;
    isAdmin: boolean = false;
    isOTD: boolean = false;
    isEndConsumner: boolean = false;
    tradePartnerId: String = '';
    istradePartnerId: boolean = false;
    createdBy: any;
    isResponsible: boolean = false;
    responsibleError: any;
    isIcb: boolean = false;
    returnUploadFiles: any;
    uploader;
    fileUploadResponse: any;
    isFileUploaded: boolean = false;
    isFileUploadError: boolean = false;
    URL: any = APPCONFIG.appUrlBase + '/uploadFiles';
    fileUrl: any = [];
    soldTo: any;
    isFocOrder: false;
    enableButtons: boolean = false;
    isShippingCountry: boolean = true;
    addressSub:Subscription;
    isD2CUser:boolean=false;
    public countries: any = countries;

contactNameId: FormControl;
contactEmailId: FormControl;
contactPhoneId: FormControl;

contactNameCtrl: FormControl = new FormControl('',[Validators.required]);
contactEmailCtrl: FormControl = new FormControl('',[Validators.required]);
contactPhoneCtrl: FormControl = new FormControl('',[Validators.required]);

 isTempContact:boolean = false;
    isExistingContactSelected:boolean = false;
    isContactModified: boolean = false;
    private _originalContact: any = null;
    countryCodeList: any[] = [];
filteredCountryCodeList: any[] = [];

filteredEmails: Observable<any[]>;
filteredPhones: Observable<any[]>;
filteredContacts: Observable<any[]>;
@ViewChildren(MdAutocompleteTrigger) private _triggers: QueryList<MdAutocompleteTrigger>;

    constructor(private router: Router, private route: ActivatedRoute, private http: HttpService, private formBuilder: FormBuilder, private commonService: CommonService,
        private sessionHandler: SessionHandler, private dialog: MdDialog, private Http: Http) {
        this.tradeData = {};
        this.requestOrder = {};
        if (this.http.checkSession()) {
            this.parcels = ["0", "1", "2", "3", "4", "5", "6", "7", "8"];
            this.selectedParcel = "0";
            this.uploader = new FileUploader({ url: this.URL, disableMultipart: true });
            this.userData = JSON.parse(this.sessionHandler.getItem('loginData'));
            let icbCheck = JSON.parse(this.sessionHandler.getItem('isIcb'));
            if (icbCheck) {
                this.isIcb = true;
            } else {
                this.isIcb = false;
            }
            this.route.params.subscribe(params => {
                this.id = +params['id'];
                if (!isNaN(this.id)) {
                    console.log('Loading Draft Order:', this.id);        
                    this.getRequestDataWithId(); 
                }
            });
            let data = this.commonService.getData();
            if (this.userData) {
                if (this.userData.role && this.userData.role.length > 0) {
                    if (this.userData.role.includes('ADMIN')) {
                        this.isAdmin = true;
                    }
                    if (this.userData.role.includes('OTD_APPROVER')) {
                        this.isOTD = true;
                    } if (this.userData.role.includes('END_CONSUMER')) {
                        this.isEndConsumner = true;
                    }
                    // ***Old***
                    // for (let u in this.userData.role) {
                    //     if (this.userData.role[u] == 'ADMIN') {
                    //         this.isAdmin = true;
                    //     }
                    //     if (this.userData.role[u] == 'OTD_APPROVER') {
                    //         this.isOTD = true;
                    //     }if (this.userData.role[u] == 'END_CONSUMER') {
                    //         this.isEndConsumner = true;                    
                    //     }
                    // }
                }
                if (data && data['requestOrder']) {
                    this.requestFormData = data;
                    this.requestOrder = data['requestOrder'];
                    this.commonService.changeViewData(data);
                } else {
                    this.requestFormData['returnOrder'] = {};
                }
                if (!this.isAdmin && !this.isOTD && !this.isEndConsumner) {
                    this.getTradeData();
                }
                if (this.isAdmin && this.requestFormData.tradeId && this.requestFormData.tradeId != null) {
                    this.tradePartnerId = this.requestFormData.tradeId;
                    this.getTradeData();
                }
                if (this.isOTD && this.requestFormData.tradeId && this.requestFormData.tradeId != null) {
                    this.tradePartnerId = this.requestFormData.tradeId;
                    this.getTradeData();
                }
                if (this.isEndConsumner && this.requestFormData.tradeId && this.requestFormData.tradeId != null) {
                    this.tradePartnerId = this.requestFormData.tradeId;
                    this.getTradeData();
                }
                if (this.isOTD && this.requestFormData.createdBy && this.requestFormData.createdBy != null) {
                    this.createdBy = this.requestFormData.createdBy;
                } else if (this.isEndConsumner && this.requestFormData.createdBy && this.requestFormData.createdBy != null) {
                    this.createdBy = this.requestFormData.createdBy;
                }
                else {
                    if ((!this.isOTD && !this.isEndConsumner) && this.userData.userName)
                        this.createdBy = this.userData.userName;
                }
            }
            this.commonService.addressChange.subscribe(() => {
                this.getAddressList();
            });
            this.commonService.contactChange.subscribe(() => {
                this.getContactList();
            });
        } else {
            this.http.showSessionError();
        }
    }

    ngOnDestroy(){
        if(this.addressSub)
        this.addressSub.unsubscribe();     //clear subscription for address change
    }

    ngOnInit() {
        this.buildForm();
        this.loadCountryCodes();
            this.filteredContacts = this.contactNameCtrl.valueChanges.pipe(
            startWith(''),
            debounceTime(100),
            map(value => this._filterContacts(value))
          );
      
          this.filteredEmails = this.contactEmailCtrl.valueChanges.pipe(
            startWith(''),
            debounceTime(100),
            map(value => this._filterEmails(value))
          );
      
          this.filteredPhones = this.contactPhoneCtrl.valueChanges.pipe(
            startWith(''),
            debounceTime(100),
            map(value => this._filterPhones(value))
          );
    }

    public scrollTo() {
        $('html, body').animate({
            scrollTop: $("#createdBy").offset().top
        }, 1000);
    }

    public getRequestDataWithId() {

        this.http.getRequest('returnOrder/v1/getReturnOrder?orderId=' + this.id)
            .subscribe(
                res => { this.saveRequestData(res) },
                err => {
                    // Log errors if any
                    if (err && err.status != 0) {
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;

                    }
                });
    }

    public tradePartnerIdEmptyheck() {
        this.resetData();
        if (this.tradePartnerId != null && this.tradePartnerId != '') {
            this.istradePartnerId = true;
        }
    }

    public responsibleEmptyheck() {
        if (this.createdBy != null && this.createdBy != '') {
            this.isResponsible = true;
        }
    }

    public getTradeData() {
        let tradeId = '';
        if (this.isAdmin || this.isOTD || this.isEndConsumner) {
            if (this.requestFormData.tradeId && this.requestFormData.tradeId != null && this.requestFormData.tradeId != '' && this.requestFormData.tradeId == this.tradePartnerId) {
                tradeId = this.requestFormData.tradeId;
            } else {
                if (isNaN(this.id)) {
                    this.resetData();
                }
                tradeId = this.tradePartnerId.trim();
            }
        } else if (this.userData && this.userData.tradePartnerId) {
            tradeId = this.userData.tradePartnerId;
        }
        if (tradeId != null && tradeId != '' && (tradeId == '50032940' || tradeId.includes('50032940'))) {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'Currently this service is not available for Uk. Please contact admin for further information.';
            this.dialogRef.afterClosed().subscribe(result => {

            });
            return;
        }
        if (tradeId != null && tradeId != '') {
            this.http.getRequest('tradePartnerDetails/v1/get?tradePartnerId=' + tradeId)
                .subscribe(
                    res => {
                        this.saveTradeData(res);
                   
                    },
                    err => {
                        this.tradePartnerId = null;
                        if (err && err.status != 0) {
                            this.dialogRef = this.dialog.open(dialogComponent);
                            this.dialogRef.componentInstance.msg = err;
                        }
                        this.http.onEnd();
                    });
        }
    }

  public saveRequestData(res) {

    if (res.responseStatus == 'Success') {

        this.requestFormData = res.returnReqDto || {};
        this.requestOrder = res.returnReqDto.requestOrder || {};
this.requestFormData.status = res.returnReqDto.status;
        // VERY IMPORTANT
        this.tradePartnerId = res.returnReqDto.tradePartnerId || '';

        if (this.isOTD || this.isEndConsumner) {
            this.createdBy = res.returnReqDto.createdBy || '';
        }
this.requestCreateForm.controls['ref'].setValue(
    this.requestOrder.ref || ''
);
this.requestCreateForm.controls['parcels'].setValue(
    this.requestOrder.parcels || 0
);

this.selectedParcel = this.requestOrder.parcels || 0;
this.selectedAddress = this.requestOrder.pickupAddressId;
this.contactNameCtrl.setValue(
    this.requestOrder.contactName || '',
    { emitEvent: false }
);

this.contactEmailCtrl.setValue(
    this.requestOrder.contactEmail || '',
    { emitEvent: false }
);

this.contactPhoneCtrl.setValue(
    this.requestOrder.contactPhone || '',
    { emitEvent: false }
);
        this.commonService.changeViewData(res.returnReqDto);

        console.log('tradePartnerId', this.tradePartnerId);

        // Load TP details, addresses and contacts
        this.getTradeData();

        this.setDefaultData();
    }

    this.http.onEnd();
}

    public saveTradeData(res) {
        this.enableButtons = true;
        this.isD2CUser = res.isD2CUser && res.isD2CUser.toLowerCase()=='true' ? true : false;/**added for  D2c one time address */
        if (res.status == "Success" && (res.tradePartner || this.isD2CUser)) {
            this.tradeData = res.tradePartner;
            this.getAddressList();
            this.updateFormValidationForD2C(this.isD2CUser);/**added for  D2c one time address */
    
        } else {
            this.tradePartnerId = null;
            this.istradePartnerId = false;
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'Trade data not found.To Create new request Please save default trade details first.';
            this.dialogRef.afterClosed().subscribe(result => {
                this.router.navigateByUrl('/app/trade/details');
                this.dialogRef = null;
            });
            this.http.onEnd();
        }
    }

    loadCountryCodes() {
  this.http.getRequest('masterData/v1/getCountryCodes').subscribe(
    (res: any) => {
      if (res && res.countryCodes) {

        this.countryCodeList = Object.keys(res.countryCodes)
          .map(name => ({
            name: name,
            code: res.countryCodes[name]
          }))
          .sort((a, b) => a.name.localeCompare(b.name));

        this.filteredCountryCodeList = this.countryCodeList;

        const existingCountry =
          this.requestCreateForm &&
          this.requestCreateForm.get('oneTimeCountryCode')
            ? this.requestCreateForm.get('oneTimeCountryCode').value
            : null;

        if (existingCountry) {
          this.validateD2CCountry(existingCountry);
        }

      } else {
        this.dialogRef = this.dialog.open(dialogComponent);
        this.dialogRef.componentInstance.msg = 'Failed to load country codes.';
      }

      this.http.onEnd();
    },
    err => {
      this.dialogRef = this.dialog.open(dialogComponent);
      this.dialogRef.componentInstance.msg =
        err && err.message ? err.message : 'Failed to load country codes.';
      this.http.onEnd();
    }
  );
}

openD2CCountryList() {
  this.filteredCountryCodeList = this.countryCodeList;
}
onD2CCountryChange(value: string) {
  const ctrl = this.requestCreateForm.get('oneTimeCountryCode');

  if (!ctrl) {
    return;
  }
const upperValue = (value || '').toUpperCase();
  ctrl.setValue(upperValue, {
emitEvent: false
});

const search = upperValue.toLowerCase();
  this.filteredCountryCodeList = this.countryCodeList.filter(c =>
    c.code.toLowerCase().includes(search) ||
    c.name.toLowerCase().includes(search)
  );

  this.validateD2CCountry(value);
}
onD2CCountrySelected(event, country) {
  // In old Angular Material, this event may fire multiple times.
  // This check prevents unwanted duplicate execution.
  if (event && event.isUserInput === false) {
    return;
  }

  const ctrl = this.requestCreateForm.get('oneTimeCountryCode');

  if (!ctrl || !country) {
    return;
  }

  ctrl.setValue(country.code);
  ctrl.setErrors(null);
  ctrl.markAsTouched();
}

validateD2CCountry(value: string) {
  const ctrl = this.requestCreateForm.get('oneTimeCountryCode');

  if (!ctrl) {
    return;
  }

  const search = (value || '').toLowerCase().trim();

  const match = this.countryCodeList.find(c =>
    c.code.toLowerCase() === search
  );

  if (match) {
    ctrl.setErrors(null);
  } else {
    ctrl.setErrors({ noMatch: true });
  }
}

    public getAddressList() {
        let tradeId;
        if (this.isAdmin || this.isOTD || this.isEndConsumner) {
            if (this.requestFormData.tradeId && this.requestFormData.tradeId != null && this.requestFormData.tradeId != '' && this.requestFormData.tradeId == this.tradePartnerId) {
                tradeId = this.requestFormData.tradeId;
            } else {
                tradeId = this.tradePartnerId;
            }
        } else if (this.userData && this.userData.tradePartnerId) {
            tradeId = this.userData.tradePartnerId;
        }
        if (tradeId != null && tradeId != '' && tradeId != undefined) {
            let data = {};
            data['tradePartnerId'] = tradeId;
            data['salesOrgId'] = APPCONFIG.salesOrgId;
            data['isICBUser'] = this.isIcb;
            this.http.postRequest(data, 'tradePartnerDetails/v1/invoiceBillingAddress')
                .subscribe(
                    res => {
                        this.saveAddressList(res);
                    },
                    err => {
                        if (err && err.status != 0) {
                            this.dialogRef = this.dialog.open(dialogComponent);
                            this.dialogRef.componentInstance.msg = err;

                        }
                        this.http.onEnd();
                    });
        }
        this.soldTo = this.tradeData.name1;
        this.requestFormData.soldTo = this.soldTo;
        //console.log('this.soldTo ' + this.soldTo);
    }


    displayContact = (value: any): string =>
  typeof value === 'string' ? value : (value && value.contactName ? value.contactName : '');

displayEmail = (value: any): string =>
  typeof value === 'string' ? value : (value && value.contactEmail ? value.contactEmail : '');

displayPhone = (value: any): string =>
  typeof value === 'string' ? value : (value && value.contactPhone ? value.contactPhone : '');



    onContactSelected(event: any,contact: any) {

  if (!event || !event.source || !event.source.selected) {
    return; // 🔒 ignore deselect / hover
  }

  // ignore deselection
 if(!contact) return;

  const id = contact && contact.id;


this.isExistingContactSelected = true;
  this.isTempContact = false;
this.isContactModified = false;

  // ✅ store original values
  this._originalContact = {
    name: contact.contactName,
    email: contact.contactEmail,
    phone: contact.contactPhone
  };


  // set all three ids to same id
  this.requestCreateForm.patchValue({
    contactNameId: id,
    contactEmailId: id,
    contactPhoneId: id
  }, { emitEvent: false });

  // set all three controls to same contact object
  this.contactNameCtrl.setValue(contact.contactName, { emitEvent: false });
  this.contactEmailCtrl.setValue(contact.contactEmail, { emitEvent: false });
  this.contactPhoneCtrl.setValue(contact.contactPhone, { emitEvent: false });

this.contactNameCtrl.updateValueAndValidity();
  this.contactEmailCtrl.updateValueAndValidity();
  this.contactPhoneCtrl.updateValueAndValidity();

  // persist draft if you’re caching between steps
  if (this.requestFormData) {
    this.requestFormData['requestOrder'] = this.requestCreateForm.getRawValue();
    this.commonService.setData(this.requestFormData);
  }
}
emailSelected(event: any, contact: any) {
  if (!event || !event.source || !event.source.selected) return;
  if (!contact) return;

  // ✅ Name selection decides identity, not email
  const hasNameId = !!this.requestCreateForm.get('contactNameId').value;

  console.log("nameid",hasNameId);

  if (!hasNameId) {
    // ❌ name is NOT from existing contact → fresh contact
    this.isExistingContactSelected = false;
    this.isTempContact = true;
    this.isContactModified = false;
    this._originalContact = null;

    this.requestCreateForm.patchValue({
      contactNameId: null,
      contactEmailId: null,
      contactPhoneId: null
    }, { emitEvent: false });
  }
  // ✅ else: keep existing contact context

  this.contactEmailCtrl.setValue(contact.contactEmail, { emitEvent: false });
  this.requestCreateForm.patchValue({
contactEmailId: contact.id
}, { emitEvent: false });
  this.contactEmailCtrl.updateValueAndValidity();

  if (this.requestFormData) {
    this.requestFormData['requestOrder'] = this.requestCreateForm.getRawValue();
    this.commonService.setData(this.requestFormData);
  }
}

phoneSelected(event: any, contact: any) {
  if (!event || !event.source || !event.source.selected) return;
  if (!contact) return;

  const hasNameId = !!this.requestCreateForm.get('contactNameId').value;

  if (!hasNameId) {
    this.isExistingContactSelected = false;
    this.isTempContact = true;
    this.isContactModified = false;
    this._originalContact = null;

    this.requestCreateForm.patchValue({
      contactNameId: null,
      contactEmailId: null,
      contactPhoneId: null
    }, { emitEvent: false });
  }

  this.contactPhoneCtrl.setValue(contact.contactPhone, { emitEvent: false });
  this.requestCreateForm.patchValue({
contactPhoneId: contact.id
}, { emitEvent: false });
  this.contactPhoneCtrl.updateValueAndValidity();

   if (this.requestFormData) {
    this.requestFormData['requestOrder'] = this.requestCreateForm.getRawValue();
    this.commonService.setData(this.requestFormData);
  }
}


    private _asText(
  val: any,
  kind: 'name' | 'email' | 'phone' | 'address' | 'soldTo'
): string {
  if (val == null) return '';

  if (typeof val === 'string') return val.trim();

  if (typeof val === 'object') {
    if (kind === 'name')    return (val.contactName || '').trim();
    if (kind === 'email')   return (val.contactEmail || '').trim();
    if (kind === 'phone')   return (val.contactPhone || '').trim();
    if (kind === 'address') return (val.address || '').trim();

    // ✅ sold-to / trade partner
    if (kind === 'soldTo') {
      return (
        val.soldTo ||
        val.tradePartnerId ||
        val.id ||
        ''
      ).toString().trim();
    }
  }

  return String(val || '').trim();
}
    getHighlightedParts(
  text: string,
  search: any,
  kind: 'name' | 'email' | 'phone' | 'address' | 'soldTo'
): { value: string; match: boolean }[] {

  if (!text) {
    return [{ value: '', match: false }];
  }

  const term = this._asText(search, kind);

  if (!term) {
    return [{ value: text, match: false }];
  }

  const escaped = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(escaped, 'ig');

  const parts: { value: string; match: boolean }[] = [];
  let lastIndex = 0;
  let m: RegExpExecArray | null;

  while ((m = regex.exec(text)) !== null) {
    const start = m.index;
    const end = start + m[0].length;

    if (start > lastIndex) {
      parts.push({
        value: text.substring(lastIndex, start),
        match: false
      });
    }

    parts.push({
      value: m[0],
      match: true
    });

    lastIndex = end;
  }

  if (lastIndex < text.length) {
    parts.push({
      value: text.substring(lastIndex),
      match: false
    });
  }

  return parts;
}
    private _triggerFor(ac: MdAutocomplete): MdAutocompleteTrigger | undefined {
      if (!this._triggers) return undefined;
      const list = this._triggers.toArray();          // QueryList → Array
      return list.find(t => t.autocomplete === ac);   // now safe
    }
    
public onContactInput(ac: MdAutocomplete, type: string) {

  switch(type) {
    case 'name':
      this.validateName();
      break;

    case 'email':
      this.validateEmail();
      break;

    case 'phone':
      this.validatePhone();
      break;
  }

  const trig = this._triggerFor(ac);

  if (trig) {
    setTimeout(() => trig.openPanel());
  }
}
private validateName() {

  const value = (this.contactNameCtrl.value || '').trim();

  const match = this.contactList.some(
    c => (c.contactName || '').trim().toLowerCase()
      === value.toLowerCase()
  );

  this.setNoMatchError(
    this.contactNameCtrl,
    value && !match
  );

  if (!match) {
    this.requestCreateForm.patchValue({
      contactNameId: null
    }, { emitEvent: false });
  }
}
private validateEmail() {

  const value = (this.contactEmailCtrl.value || '').trim();

  const match = this.contactList.some(
    c => (c.contactEmail || '').trim().toLowerCase()
      === value.toLowerCase()
  );

  this.setNoMatchError(
    this.contactEmailCtrl,
    value && !match
  );

  if (!match) {
    this.requestCreateForm.patchValue({
      contactEmailId: null
    }, { emitEvent: false });
  }
}
private validatePhone() {

  const value = (this.contactPhoneCtrl.value || '').trim();

  const match = this.contactList.some(
    c => (c.contactPhone || '').trim() === value
  );

  this.setNoMatchError(
    this.contactPhoneCtrl,
    value && !match
  );

  if (!match) {
    this.requestCreateForm.patchValue({
      contactPhoneId: null
    }, { emitEvent: false });
  }
}
private normalizeValue(value: any): string {
    return (value == null ? '' : String(value)).trim();
}

private normalizeEmail(value: any): string {
    return this.normalizeValue(value).toLowerCase();
}

private findExactContactByTypedValues(): any {
    if (!this.contactList || this.contactList.length === 0) {
        return null;
    }

    const name = this.normalizeValue(this.contactNameCtrl.value);
    const email = this.normalizeEmail(this.contactEmailCtrl.value);
    const phone = this.normalizeValue(this.contactPhoneCtrl.value);

    if (!name || !email || !phone) {
        return null;
    }

    return this.contactList.find(c =>
        this.normalizeValue(c.contactName) === name &&
        this.normalizeEmail(c.contactEmail) === email &&
        this.normalizeValue(c.contactPhone) === phone
    );
}

private setNoMatchError(ctrl: FormControl, hasError: boolean) {
    const errors = ctrl.errors || {};

    if (hasError) {
        errors['noMatch'] = true;
        ctrl.setErrors(errors);
    } else {
        if (errors['noMatch']) {
            delete errors['noMatch'];
        }

        ctrl.setErrors(Object.keys(errors).length ? errors : null);
    }
}

private clearContactIds() {
    this.requestCreateForm.patchValue({
        contactNameId: null,
        contactEmailId: null,
        contactPhoneId: null
    }, { emitEvent: false });

    this.isExistingContactSelected = false;
    this.isTempContact = false;
    this.isContactModified = false;
    this._originalContact = null;
}
private clearNameId() {
   this.requestCreateForm.patchValue({
      contactNameId: null
   }, { emitEvent:false });
}

private clearEmailId() {
   this.requestCreateForm.patchValue({
      contactEmailId: null
   }, { emitEvent:false });
}

private clearPhoneId() {
   this.requestCreateForm.patchValue({
      contactPhoneId: null
   }, { emitEvent:false });
}

private syncContactFromTypedValues() {
    const name = this.normalizeValue(this.contactNameCtrl.value);
    const email = this.normalizeEmail(this.contactEmailCtrl.value);
    const phone = this.normalizeValue(this.contactPhoneCtrl.value);

    const allEmpty = !name && !email && !phone;

    if (allEmpty) {
        this.clearContactIds();

        this.setNoMatchError(this.contactNameCtrl, false);
        this.setNoMatchError(this.contactEmailCtrl, false);
        this.setNoMatchError(this.contactPhoneCtrl, false);

        return;
    }

    const exactContact = this.findExactContactByTypedValues();

    if (exactContact) {
        this.requestCreateForm.patchValue({
            contactNameId: exactContact.id,
            contactEmailId: exactContact.id,
            contactPhoneId: exactContact.id
        }, { emitEvent: false });

        this.isExistingContactSelected = true;
        this.isTempContact = false;
        this.isContactModified = false;

        this._originalContact = {
            name: exactContact.contactName,
            email: exactContact.contactEmail,
            phone: exactContact.contactPhone
        };

        this.setNoMatchError(this.contactNameCtrl, false);
        this.setNoMatchError(this.contactEmailCtrl, false);
        this.setNoMatchError(this.contactPhoneCtrl, false);

        return;
    }

    this.clearContactIds();

    this.setNoMatchError(this.contactNameCtrl, !!name);
    this.setNoMatchError(this.contactEmailCtrl, !!email && !this.contactEmailCtrl.hasError('email'));
    this.setNoMatchError(this.contactPhoneCtrl, !!phone);
}


      openPanelFor(ac: MdAutocomplete, sourceList: any[]) {
      if (!sourceList || sourceList.length === 0) return;
    
      // 🔁 Make sure all filters emit at least once when inputs are empty.
      if (this.contactNameCtrl.value == null || this.contactNameCtrl.value === '') {
        this.contactNameCtrl.setValue('', { emitEvent: true });
      }
      if (this.contactEmailCtrl.value == null || this.contactEmailCtrl.value === '') {
        this.contactEmailCtrl.setValue('', { emitEvent: true });
      }
      if (this.contactPhoneCtrl.value == null || this.contactPhoneCtrl.value === '') {
        this.contactPhoneCtrl.setValue('', { emitEvent: true });
      }
    
      const trig = this._triggerFor(ac);
      if (trig) {
        setTimeout(() => trig.openPanel());
      }
    }

    public getContactList() {
        let tradeId;
        if (this.isAdmin || this.isOTD || this.isEndConsumner) {
            if (this.requestFormData.tradeId && this.requestFormData.tradeId != null && this.requestFormData.tradeId != '' && this.requestFormData.tradeId == this.tradePartnerId) {
                tradeId = this.requestFormData.tradeId;
            } else {
                tradeId = this.tradePartnerId;
            }
        } else if (this.userData && this.userData.tradePartnerId) {
            tradeId = this.userData.tradePartnerId;
        }
        if (tradeId != null && tradeId != '') {
            this.http.getRequest('userOperationsApi/v1/getContacts?tradePartnerId=' + tradeId)
                .subscribe(
                    res => { this.saveContactList(res) },
                    err => {
                        if (err && err.status != 0) {
                            this.dialogRef = this.dialog.open(dialogComponent);
                            this.dialogRef.componentInstance.msg = err;

                        }
                        this.http.onEnd();
                    });
        }
    }

    public saveAddressList(res) {
        if (res.billingAddress) {
            this.billingData = res.billingAddress;
        }
        if (res.shippingAddressList.length > 0) {
            this.addressList = res.shippingAddressList;
            this.getContactList();
        } else {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'To create new request please save address details first.';
            // alert('To create new request please save address details first.');
            this.http.onEnd();
            this.router.navigateByUrl('/app/trade/details');
        }
    }

    public saveContactList(res) {

        if(!this.isD2CUser){

            if (res.items.length > 0) {
                this.contactList = res.items;
                this.refreshContactFilters();
                this.setDefaultData();
            } else {
                this.dialogRef = this.dialog.open(dialogComponent);
                this.dialogRef.componentInstance.msg = 'To create new request please save contact details first.';
                this.http.onEnd();
                this.router.navigateByUrl('/app/trade/details');
            }
        }else{
            if (this.billingData.id) {
                this.requestCreateForm.controls['soldToId'].setValue(this.billingData.id);
            }
            this.http.onEnd();

        }
    }
private refreshContactFilters() {
    this.contactNameCtrl.setValue(this.contactNameCtrl.value || '', { emitEvent: true });
    this.contactEmailCtrl.setValue(this.contactEmailCtrl.value || '', { emitEvent: true });
    this.contactPhoneCtrl.setValue(this.contactPhoneCtrl.value || '', { emitEvent: true });
}
    public buildForm() {
        this.requestCreateForm = this.formBuilder.group({
            pickupSame: this.formBuilder.control(this.requestOrder.pickupSame ? this.requestOrder.pickupSame : "true", []),
            pickupAddressId: this.formBuilder.control(this.requestOrder.pickupAddressId ? this.requestOrder.pickupAddressId : null, [Validators.required]),
            contactNameId: this.formBuilder.control(this.requestOrder.contactNameId ? this.requestOrder.contactNameId : null, [Validators.required]),
            contactEmailId: this.formBuilder.control(this.requestOrder.contactEmailId ? this.requestOrder.contactEmailId : null, [Validators.required]),
            contactPhoneId: this.formBuilder.control(this.requestOrder.contactPhoneId ? this.requestOrder.contactPhoneId : null, [Validators.required]),
            instructions: this.formBuilder.control(this.requestOrder.instructions ? this.requestOrder.instructions : ' ', [Validators.required]),
            palletSelected: this.formBuilder.control(this.requestOrder.palletSelected ? this.requestOrder.palletSelected : "false", []),
            pallet: this.formBuilder.control({ value: this.requestOrder.pallet ? this.requestOrder.pallet : 'No Pallet', disabled: true }, Validators.required),
            parcels: this.formBuilder.control(this.requestOrder.parcels ? this.requestOrder.parcels : 0, [Validators.required]),
            ref: this.formBuilder.control(this.requestOrder.ref ? this.requestOrder.ref : null, [Validators.required]),
            comment: this.formBuilder.control(this.requestOrder.comment ? this.requestOrder.comment : null, []),
            fileUrl: this.formBuilder.control(this.fileUrl ? this.fileUrl : [], []),
            // shippingCountry: this.formBuilder.control(this.requestOrder.shippingCountry ? this.requestOrder.shippingCountry : null, [Validators.required]),
            isFocOrder: false,
            isCoustumerManaged: false,
            soldToId: this.formBuilder.control(this.billingData.id ? this.billingData.id : null, []),

            /**added for  D2c one time address */
            oneTimeFirstName: this.formBuilder.control(this.requestOrder && this.requestOrder.tpDetails && this.requestOrder.tpDetails.name1 ? this.requestOrder.tpDetails.name1 : null, [Validators.required]),
            oneTimeLastName: this.formBuilder.control(this.requestOrder && this.requestOrder.tpDetails && this.requestOrder.tpDetails.name2 ? this.requestOrder.tpDetails.name2 : null, [Validators.required]),
            oneTimeemail: this.formBuilder.control(this.requestOrder && this.requestOrder.tpDetails && this.requestOrder.tpDetails.contactEmail ? this.requestOrder.tpDetails.contactEmail : null, [Validators.email]),
            oneTimePhoneNumber: this.formBuilder.control(this.requestOrder && this.requestOrder.tpDetails && this.requestOrder.tpDetails.contactPhone ? this.requestOrder.tpDetails.contactPhone  : null, [Validators.required]),
            oneTimeStreet: this.formBuilder.control(this.requestOrder && this.requestOrder.tpDetails && this.requestOrder.tpDetails.street ? this.requestOrder.tpDetails.street  : null, [Validators.required,]),
            oneTimeCity: this.formBuilder.control(this.requestOrder && this.requestOrder.tpDetails && this.requestOrder.tpDetails.city ? this.requestOrder.tpDetails.city  : null, [Validators.required]),
            oneTimePostalCode: this.formBuilder.control(this.requestOrder && this.requestOrder.tpDetails && this.requestOrder.tpDetails.zipCode ? this.requestOrder.tpDetails.zipCode  : null, [Validators.required]),
            oneTimeCountryCode: this.formBuilder.control(this.requestOrder && this.requestOrder.tpDetails && this.requestOrder.tpDetails.country ? this.requestOrder.tpDetails.country : null, [Validators.required]),
            /** */


        });

this.contactNameId = this.requestCreateForm.get('contactNameId') as FormControl;
this.contactEmailId = this.requestCreateForm.get('contactEmailId') as FormControl;
this.contactPhoneId = this.requestCreateForm.get('contactPhoneId') as FormControl;

        // this.requestCreateForm.get('shippingCountry').disable();
        this.requestOrder.shippingCountry ? this.selectedCountry = this.requestOrder.shippingCountry : '';
        this.requestCreateForm.get('pickupSame').valueChanges.subscribe(data => {
            this.checkSameAddress(data);
        });
        this.requestCreateForm.get('palletSelected').valueChanges.subscribe(data => {
            this.checkPallet(data)
        });
        // this.requestCreateForm.get('isCoustumerManaged').valueChanges.subscribe(data => {
        //     this.CoustumerManaged(data)
        // });
    }

    public resetData() {
        this.requestOrder = {};
        this.tradeData = {};
        this.requestCreateForm.controls['pickupSame'].setValue('true');
        this.requestCreateForm.controls['pickupAddressId'].setValue(null);
        this.requestCreateForm.controls['contactNameId'].setValue(null);
        this.requestCreateForm.controls['contactEmailId'].setValue(null);
        this.requestCreateForm.controls['contactPhoneId'].setValue(null);
        this.requestCreateForm.controls['instructions'].setValue('');
        this.requestCreateForm.controls['palletSelected'].setValue('false');
        this.requestCreateForm.controls['parcels'].setValue(null);
        this.requestCreateForm.controls['pallet'].setValue('No Pallet');
        this.requestCreateForm.controls['ref'].setValue(null);
        // this.requestCreateForm.controls['shippingCountry'].setValue(null);
        this.selectedParcel = this.parcels[0];
        this.selectedAddress = null;
        this.selectedContactName = null;
        this.selectedContactEmail = null;
        this.selectedContactPhone = null;
        this.selectedParcel = null;
        this.addressList = [];
        this.contactList = [];
        this.enableButtons = false;
        this.isShippingCountry = true;
        this.selectedCountry = ''
    }
private _filterContacts(value: any): any[] {

        if (!this.contactList) return [];
      
        let search = '';
      
        // when typing
        if (typeof value === 'string') {
          search = value.toLowerCase();
        }
        // when object selected
        else if (value && value.contactName) {
          search = value.contactName.toLowerCase();
        }
      
        if (!search) {
          return this.contactList.slice();
        }
      
        return this.contactList.filter(c =>
          c.contactName &&
          c.contactName.toLowerCase().includes(search)
        );
      }

      private _filterEmails(value: any): any[] {

        if (!this.contactList) return [];
      
        let search = '';
      
        if (typeof value === 'string') {
          search = value.toLowerCase();
        } else if (value && value.contactEmail) {
          search = value.contactEmail.toLowerCase();
        }
      
        if (!search) return this.contactList.slice();
      
        return this.contactList.filter(c =>
          (c.contactEmail || '').toLowerCase().includes(search)
        );
      }

      private _filterPhones(value: any): any[] {

        if (!this.contactList) return [];
      
        let search = '';
      
        if (typeof value === 'string') {
          search = value;
        } else if (value && value.contactPhone) {
          search = value.contactPhone;
        }
      
        if (!search) return this.contactList.slice();
      
        return this.contactList.filter(c =>
          (c.contactPhone || '').includes(search)
        );
      }

   
      

      displayAddress = (address: any): string => {
        return address && address.address
          ? address.address
          : '';
      };
    public setDefaultData() {
        console.log('requestOrder=', this.requestOrder);
        if (Object.keys(this.requestOrder).length > 0) {

    this.selectedAddress = this.requestOrder.pickupAddressId;

    for (let i in this.contactList) {

        if (
            this.contactList[i].contactName &&
            this.requestOrder.contactName &&
            this.contactList[i].contactName.trim() === this.requestOrder.contactName.trim()
        ) {
            this.selectedContactName = this.contactList[i].id;
        }

        if (
            this.contactList[i].contactEmail &&
            this.requestOrder.contactEmail &&
            this.contactList[i].contactEmail.trim().toLowerCase() ===
            this.requestOrder.contactEmail.trim().toLowerCase()
        ) {
            this.selectedContactEmail = this.contactList[i].id;
        }

        if (
            this.contactList[i].contactPhone &&
            this.requestOrder.contactPhone &&
            this.contactList[i].contactPhone.trim() === this.requestOrder.contactPhone.trim()
        ) {
            this.selectedContactPhone = this.contactList[i].id;
        }
    }

    this.contactNameCtrl.setValue(
        this.requestOrder.contactName || '',
        { emitEvent: false }
    );

    this.contactEmailCtrl.setValue(
        this.requestOrder.contactEmail || '',
        { emitEvent: false }
    );

    this.contactPhoneCtrl.setValue(
        this.requestOrder.contactPhone || '',
        { emitEvent: false }
    );

    this.requestCreateForm.patchValue({
        pickupAddressId: this.requestOrder.pickupAddressId || null,
        ref: this.requestOrder.ref || '',
        parcels: this.requestOrder.parcels || '0'
    });
    this.requestCreateForm.patchValue({
    contactNameId: this.selectedContactName,
    contactEmailId: this.selectedContactEmail,
    contactPhoneId: this.selectedContactPhone,
    pickupAddressId: this.selectedAddress,
    ref: this.requestOrder.ref || '',
    parcels: this.requestOrder.parcels || '0'
},{ emitEvent: false });

} else if (this.tradeData && Object.keys(this.requestOrder).length === 0) {
            if (this.tradeData.contactNameId) {
                this.selectedContactName = this.tradeData.contactNameId;
            } else {
                for (let i in this.contactList) {
                    if (this.contactList[i].contactName == this.tradeData.contactName) {
                        this.selectedContactName = this.contactList[i].id;
                    }
                }
            }
            if (this.tradeData.contactEmailId) {
                this.selectedContactEmail = this.tradeData.contactEmailId;
            } else {
                for (let i in this.contactList) {
                    if (this.contactList[i].contactEmail == this.tradeData.contactEmail) {
                        this.selectedContactEmail = this.contactList[i].id;
                    }
                }
            }
            if (this.tradeData.contactPhoneId) {
                this.selectedContactPhone = this.tradeData.contactPhoneId;
            } else {
                for (let i in this.contactList) {
                    if (this.contactList[i].contactPhone == this.tradeData.contactPhone) {
                        this.selectedContactPhone = this.contactList[i].id;
                    }
                }
            }

            
        }
        if (this.requestOrder.instructions) {
            this.requestCreateForm.controls['instructions'].setValue(this.requestOrder.instructions);
        } else if (this.tradeData && this.tradeData.instructions) {
            this.requestCreateForm.controls['instructions'].setValue(this.tradeData.instructions);
        } else {
            this.requestCreateForm.controls['instructions'].setValue('');
        }
        if (Object.keys(this.requestOrder).length > 0) {
            if (this.requestOrder.palletSelected == false || this.requestOrder.palletSelected == 'false') {
                this.requestCreateForm.controls['palletSelected'].setValue("false");
                this.checkPallet('false');
            } else if (this.requestOrder.palletSelected == true || this.requestOrder.palletSelected == 'true') {
                this.requestCreateForm.controls['palletSelected'].setValue("true");
                this.checkPallet('true');
            }
            if (this.requestOrder.isCoustumerManaged == false || this.requestOrder.isCoustumerManaged == 'false') {
                this.requestCreateForm.controls['isCoustumerManaged'].setValue("false");
                //  this.CoustumerManaged('false');
            } else if (this.requestOrder.isCoustumerManaged == true || this.requestOrder.isCoustumerManaged == 'true') {
                this.requestCreateForm.controls['isCoustumerManaged'].setValue("true");
                // this.CoustumerManaged('true');
            }
            if (this.requestOrder.pickupSame == true || this.requestOrder.pickupSame == 'true') {
                this.requestCreateForm.controls['pickupSame'].setValue("true");
                this.checkSameAddress('true');
            } else if (this.requestOrder.pickupSame == false || this.requestOrder.pickupSame == 'false') {
                this.requestCreateForm.controls['pickupSame'].setValue("false");
                this.checkSameAddress('false');
            }
        } else {
            this.setDefaultAddress();
        }
        if (this.requestOrder.ref) {
            this.requestCreateForm.controls['ref'].setValue(this.requestOrder.ref);
        }
        this.http.onEnd();
        console.log("status :- "+ this.requestOrder.status);
        if (this.requestFormData && this.requestFormData.status !== 'DRAFT'){
        this.populateSelectedContactDisplay();
        }
    }
    private populateSelectedContactDisplay() {
  if (!this.contactList || this.contactList.length === 0) return;

  const nameId = this.selectedContactName;
  const emailId = this.selectedContactEmail;
  const phoneId = this.selectedContactPhone;

  const contact =
    this.contactList.find(c => c.id == nameId) ||
    this.contactList.find(c => c.id == emailId) ||
    this.contactList.find(c => c.id == phoneId);

  if (!contact) return;

  this.requestCreateForm.patchValue({
    contactNameId: contact.id,
    contactEmailId: contact.id,
    contactPhoneId: contact.id
  }, { emitEvent: false });

  this.contactNameCtrl.setValue(contact.contactName || '', { emitEvent: false });
  this.contactEmailCtrl.setValue(contact.contactEmail || '', { emitEvent: false });
  this.contactPhoneCtrl.setValue(contact.contactPhone || '', { emitEvent: false });
}

    public isInArray(value, array) {
        return array.indexOf(value) > -1;
    }

    public setDefaultAddress() {
        if (this.addressList && this.billingData) {

            if (this.billingData.id) {
                this.requestCreateForm.controls['soldToId'].setValue(this.billingData.id);
            }
            let length = this.addressList.length;
            let count = 0;
            for (let i in this.addressList) {
                if (this.addressList[i].address == this.billingData.invoiceAddress) {
                    this.selectedAddress = this.addressList[i].id;
                    this.selectedCountry = this.addressList[i].country;

                    if (this.addressList[i].country == "") {
                        this.isShippingCountry = false;
                    }
                    let rawData = this.requestCreateForm.getRawValue();
                    if (rawData.pickupSame != "true") {
                        this.requestCreateForm.controls['pickupSame'].setValue("true");
                    }
                    this.requestCreateForm.get('pickupAddressId').disable();
                    return true;
                } else {
                    count++;
                }
            }
            if (count == length) {
                this.requestCreateForm.controls['pickupSame'].setValue("false");
            }
        }
        // if(this.isShippingCountry){
        //     this.requestCreateForm.get('shippingCountry').clearValidators();    
        //     this.requestCreateForm.get('shippingCountry').updateValueAndValidity();                            
        // }else{
        //     this.requestCreateForm.get('shippingCountry').setValidators(Validators.required);               
        //     this.requestCreateForm.get('shippingCountry').updateValueAndValidity();                 
        // }
    }

    public checkPallet(check) {
        let control = this.requestCreateForm.get('pallet');
        let control1 = this.requestCreateForm.get('parcels');
        let control2 = this.requestCreateForm.get('isCoustumerManaged');
        var isCoustumerManaged = control2.value;
        //     if(!isCoustumerManaged){
        if (check == "true") {
            if (this.requestOrder.pallet != '0' && this.requestOrder.pallet != "No Pallet") {
                this.requestCreateForm.controls['pallet'].setValue(this.requestOrder.pallet);
            } else {
                this.requestCreateForm.controls['pallet'].setValue(null);
            }
            this.requestCreateForm.controls['parcels'].setValue('No Parcel');
            control.enable()
            control1.disable();
        } else {
            this.requestCreateForm.controls['pallet'].setValue('No Pallet');
            if (this.requestOrder.parcels != '') {
                this.selectedParcel = this.requestOrder.parcels;
            } else {
                this.requestCreateForm.controls['parcels'].setValue(null);
            }
            control.disable();
            control1.enable();
        }
        //  }

    }

    public onlyNumber(evt) {
        if (/^[0-9]+$/i.test(String.fromCharCode(evt.charCode)) == false) {
            evt.returnValue = false;
            return false;
        }
    }

    public checkSameAddress(check) {
        if (check == 'true') {
            let res = this.setDefaultAddress();
            if (res) {
                this.requestCreateForm.get('pickupAddressId').disable();
                // this.requestCreateForm.get('shippingCountry').disable();
            }
        } else {
            this.requestCreateForm.get('pickupAddressId').enable();
            if (this.requestOrder.pickupAddressId) {
                this.selectedAddress = this.requestOrder.pickupAddressId;
            } else if (this.tradeData.addressId) {
                let check = false;
                for (let a in this.addressList) {
                    if (this.addressList[a].id == this.tradeData.addressId) {
                        this.selectedAddress = this.tradeData.addressId;
                        // this.onChange(this.selectedAddress); 
                        check = true;
                    }
                }
                if (!check) {
                    this.requestCreateForm.controls['pickupAddressId'].setValue(null);
                    // this.requestCreateForm.controls['shippingCountry'].setValue(null);
                }
            } else if (this.addressList && this.addressList.length > 0) {
                let length = this.addressList.length;
                this.selectedAddress = this.addressList[length - 1].id;
            }
        }

        this.addressSub = this.commonService.addressSourceObs.subscribe(res=>{            //subscribe to addressChange and check if different address ids
            if (res !== this.selectedAddress && this.addressList && this.requestCreateForm.controls['pickupSame'].value =="false") {
                for (let i in this.addressList) {
                    if (this.addressList[i].id == res) {                                   //set new address and country
                        this.selectedAddress = res;
                        // this.onChange(this.selectedAddress);
                    }
                }
            }
        });
    }

    public setFormDetails() {
        if (this.addressList) {
            for (let i in this.addressList) {
                if (this.addressList[i].id == this.requestFormData.requestOrder.pickupAddressId) {
                    this.requestFormData.requestOrder.pickupAddress = this.addressList[i].address;
                    this.requestFormData['requestOrder'].tradePartnerAddress = this.addressList[i];
                }
            }
        }
        if (this.contactList) {
            for (let i in this.contactList) {
                if (this.contactList[i].id == this.requestFormData.requestOrder.contactNameId) {
                    this.requestFormData.requestOrder.contactName = this.contactList[i].contactName;
                }
                if (this.contactList[i].id == this.requestFormData.requestOrder.contactEmailId) {
                    this.requestFormData.requestOrder.contactEmail = this.contactList[i].contactEmail;
                }
                if (this.contactList[i].id == this.requestFormData.requestOrder.contactPhoneId) {
                    this.requestFormData.requestOrder.contactPhone = this.contactList[i].contactPhone;
                }
            }
        }
        return true;
    }

    public goToNextPage() {
        this.requestFormData['requestOrder'] = this.requestCreateForm.getRawValue();
        this.responseSaveForD2cUser();/**added for  D2c one time address */
        if (this.isAdmin) {
            this.requestFormData.tradeId = this.tradePartnerId.replace(/^0+/, '');
        }
        if (this.isOTD || this.isEndConsumner) {
            this.requestFormData.createdBy = this.createdBy;
            this.requestFormData.tradeId = this.tradePartnerId.replace(/^0+/, '');
        }
        if ((this.isOTD || this.isEndConsumner) && (!this.createdBy || this.createdBy == '')) {
            this.scrollTo();
            this.responsibleError = 'Please enter employee responsible.'
        } else {
            this.requestFormData.createdBy = this.createdBy;
            this.responsibleError = null;
            if (this.setFormDetails()) {
                console.log(this.requestFormData)
                this.commonService.setData(this.requestFormData);
                if (!isNaN(this.id)) {
                    this.router.navigateByUrl('/app/requests/return/' + this.id);
                } else {
                    this.router.navigateByUrl('/app/requests/return');
                }
            }
        }
    }

    public save() {
        this.requestFormData['requestOrder'] = this.requestCreateForm.getRawValue();
        if (this.isAdmin || this.isOTD || this.isEndConsumner) {
            this.requestFormData.tradeId = this.tradePartnerId.replace(/^0+/, '');
        }
        if (this.setFormDetails()) {
            this.requestFormData.email = this.userData.email;
            this.requestFormData.userId = this.userData.userId;
            this.requestFormData.tradePartnerId = this.userData.tradePartnerId;
            this.http.postRequest(this.requestFormData, 'returnOrder/v1/saveReturnOrder').subscribe(
                res => {
                    this.saveResponse(res);
                },
                err => {
                    if (err && err.status != 0) {
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = 'Save Failed';

                    }
                    this.http.onEnd();
                }
            );
        }
    }

    public saveResponse(res) {
        this.http.onEnd();
        if (res.status == 'Success') {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'Request Saved As Draft';
            this.commonService.setData(null);
            this.router.navigateByUrl('/app/dashboard');
        }
        if (res.status == 'Error') {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = res.errorMessage;
        }
    }

    uploadFile(data: any) {
        console.log(data);
        console.log(data.target.files[0]);
        let i = 0;
        let input = new FormData();
        while (i < data.target.files.length) {

            //input = data.target.files[i];
            input.append("files", data.target.files[i]);
            console.log('file found')
            i++;
        }
        this.requestFormData.returnUploadFiles = input;
        console.log(this.requestFormData.returnUploadFiles);

    }

    public fileupload() {
        let formData = new FormData();
        for (let i in this.uploader.queue) {
            this.http.showLoader();
            this.isFileUploaded = true;
            formData.append('file', this.uploader.queue[i]._file);
            let headers = new Headers({ 'apiKey': 'AIzaSyDYlzt8e-7tSUzzDS802X_4RgQMmx0N79Y', 'access-token': this.sessionHandler.getItem('token') });
            this.sessionHandler.saveItem("timestamp", Math.round(new Date().getTime() / 1000.0));
            this.Http
                .post(this.URL, formData, { headers: headers })
                .toPromise()
                .then(res => this.setUploadData(res.json()))
                .catch(error => this.handleError(error))
        }
    }
    public handleError(e) {
        //this.showError(e, false);
        console.log('error found -- file upload....' + e);
        this.fileUploadResponse = e;
        this.isFileUploadError = true;
        this.http.onEnd();
    }

    public setUploadData(res) {

        this.uploader = new FileUploader({ url: this.URL, disableMultipart: true });
        if (res.responseCode == 200) {
            this.isFileUploadError = false;
            this.fileUrl.push({
                "fileName": res.documentName ? res.documentName : '',
                "fileUrl": res.fileUrl
            });
            this.commonService.setWrtImageData(this.fileUrl);
            // this.fileUrl.push(res.fileUrl);
            this.fileUploadResponse = res.message;
        } else if (res.responseCode == 400) {
            this.isFileUploadError = true;
            this.fileUploadResponse = res.message;
        }
        this.http.onEnd();
    }
    CoustumerManaged(check) {
        let control = this.requestCreateForm.get('pallet');
        let control1 = this.requestCreateForm.get('parcels');
        let controlselected = this.requestCreateForm.get('palletSelected');


        if (check) {
            this.requestCreateForm.controls['parcels'].setValue('No Parcel');
            this.requestCreateForm.controls['pallet'].setValue('No Pallet');
            control.disable();
            control1.disable();
            controlselected.disable();
        } else {
            this.requestCreateForm.get('palletSelected').valueChanges.subscribe(data => {
                this.checkPallet(data)
            });
            controlselected.enable();

        }
    }

    public onChange(data) {                                     //function to select country on address change
        try {
            this.isShippingCountry = true;
            if (data && this.addressList)                                           //check address id and current selected id(data)
                this.addressList.forEach(ele => {
                    if (Number(data) === Number(ele.id)) {
                        ele.country.length > 0 ? this.countryFromID = ele.country : this.countryFromID = '';
                    }
                    else this.selectedCountry = '';
                });

            // if (this.countryFromID !== '') {                      //if ids match find country using country code, disable and validate
            //     this.countries.forEach(country => {
            //         if (this.countryFromID.toUpperCase() === country.code.toUpperCase()) {
            //             this.selectedCountry = country.code;
            //             this.requestCreateForm.get('shippingCountry').disable();
            //             this.requestCreateForm.get('shippingCountry').setValidators(Validators.required);
            //             this.requestCreateForm.get('shippingCountry').updateValueAndValidity();
            //         }
            //     });
            // }
            // else this.selectedCountry = '';

            // if (this.selectedCountry === '' || this.countryFromID === '') { //else reset, validate and enable country drop down
            //     this.requestCreateForm.get('shippingCountry').enable();
            //     this.requestCreateForm.get('shippingCountry').reset();
            //     this.requestCreateForm.get('shippingCountry').setValidators(Validators.required);
            //     this.requestCreateForm.get('shippingCountry').updateValueAndValidity();
            // }
        } catch (error) {
            console.log('exception occured', error);
        }

    }

    // Previous function renamed and commented by Vedika M.
    //   public onChangeCountry(country: string){
    //       try {
    //         this.requestCreateForm.get('shippingCountry').setValue(null); 
    //         this.requestCreateForm.get('shippingCountry').updateValueAndValidity();                            
    //         this.isShippingCountry=true;
    //         const newVal = country;
    //         for(let i=0;i<this.addressList.length;i++){
    //             if(newVal==this.addressList[i].id){
    //                 if(this.addressList[i].country===""){
    //                      this.isShippingCountry=false;
    //                }
    //                break;
    //               }
    //           }
    //           if(this.isShippingCountry){
    //             this.requestCreateForm.get('shippingCountry').clearValidators();    
    //             this.requestCreateForm.get('shippingCountry').updateValueAndValidity();                            
    //             }else{
    //                 this.requestCreateForm.get('shippingCountry').setValidators(Validators.required);               
    //                 this.requestCreateForm.get('shippingCountry').updateValueAndValidity();
    //             }
    //       } catch (error) {

    //       }
    //   

    public saveNewAddress() {
        let tradeId;
        if (this.isAdmin || this.isOTD || this.isEndConsumner) {
            if (this.requestFormData.tradeId && this.requestFormData.tradeId != null && this.requestFormData.tradeId != '' && this.requestFormData.tradeId == this.tradePartnerId) {
                tradeId = this.requestFormData.tradeId;
            } else {
                tradeId = this.tradePartnerId;
            }
        } else if (this.userData && this.userData.tradePartnerId) {
            tradeId = this.userData.tradePartnerId;
        }
        this.dialogRef = this.dialog.open(addNewAddressComponent);
        this.dialogRef.componentInstance.tradeId = tradeId;
    }

    public saveNewContact() {
        let tradeId;
        if (this.isAdmin || this.isOTD || this.isEndConsumner) {
            if (this.requestFormData.tradeId && this.requestFormData.tradeId != null && this.requestFormData.tradeId != '' && this.requestFormData.tradeId == this.tradePartnerId) {
                tradeId = this.requestFormData.tradeId;
            } else {
                tradeId = this.tradePartnerId;
            }
        } else if (this.userData && this.userData.tradePartnerId) {
            tradeId = this.userData.tradePartnerId;
        }
        this.dialogRef = this.dialog.open(addNewContactComponent);
        this.dialogRef.componentInstance.tradeId = tradeId;
        //this.getAddressList('saved');
    }

    updateFormValidationForD2C(isD2CUser){/**added for  D2c one time address */
    if(isD2CUser){
            this.requestCreateForm.get('pickupSame').clearValidators();
            this.requestCreateForm.get('pickupSame').updateValueAndValidity(); 
            
            this.requestCreateForm.get('pickupAddressId').clearValidators();
            this.requestCreateForm.get('pickupAddressId').updateValueAndValidity(); 

            this.requestCreateForm.get('contactNameId').clearValidators();
            this.requestCreateForm.get('contactNameId').updateValueAndValidity(); 

            this.requestCreateForm.get('contactEmailId').clearValidators();
            this.requestCreateForm.get('contactEmailId').updateValueAndValidity(); 

            this.requestCreateForm.get('contactPhoneId').clearValidators();
            this.requestCreateForm.get('contactPhoneId').updateValueAndValidity(); 

            this.requestCreateForm.get('instructions').clearValidators();
            this.requestCreateForm.get('instructions').updateValueAndValidity(); 

            this.requestCreateForm.get('palletSelected').clearValidators();
            this.requestCreateForm.get('palletSelected').updateValueAndValidity(); 

            this.requestCreateForm.get('pallet').clearValidators();
            this.requestCreateForm.get('pallet').updateValueAndValidity(); 

            this.requestCreateForm.get('parcels').clearValidators();
            this.requestCreateForm.get('parcels').updateValueAndValidity(); 

            this.requestCreateForm.get('ref').clearValidators();
            this.requestCreateForm.get('ref').updateValueAndValidity(); 

            this.requestCreateForm.get('comment').clearValidators();
            this.requestCreateForm.get('comment').updateValueAndValidity(); 

            this.requestCreateForm.get('fileUrl').clearValidators();
            this.requestCreateForm.get('fileUrl').updateValueAndValidity(); 

            // this.requestCreateForm.get('shippingCountry').clearValidators();
            // this.requestCreateForm.get('shippingCountry').updateValueAndValidity(); 

            // this.requestCreateForm.get('soldToId').clearValidators();
            // this.requestCreateForm.get('soldToId').updateValueAndValidity(); 
    }else{
            this.requestCreateForm.get('oneTimeFirstName').clearValidators();
            this.requestCreateForm.get('oneTimeFirstName').updateValueAndValidity(); 

            this.requestCreateForm.get('oneTimeLastName').clearValidators();
            this.requestCreateForm.get('oneTimeLastName').updateValueAndValidity(); 

            this.requestCreateForm.get('oneTimeemail').clearValidators();
            this.requestCreateForm.get('oneTimeemail').updateValueAndValidity(); 

            this.requestCreateForm.get('oneTimePhoneNumber').clearValidators();
            this.requestCreateForm.get('oneTimePhoneNumber').updateValueAndValidity(); 

            this.requestCreateForm.get('oneTimeStreet').clearValidators();
            this.requestCreateForm.get('oneTimeStreet').updateValueAndValidity(); 

            this.requestCreateForm.get('oneTimeCity').clearValidators();
            this.requestCreateForm.get('oneTimeCity').updateValueAndValidity(); 

            this.requestCreateForm.get('oneTimePostalCode').clearValidators();
            this.requestCreateForm.get('oneTimePostalCode').updateValueAndValidity(); 

            this.requestCreateForm.get('oneTimeCountryCode').clearValidators();
            this.requestCreateForm.get('oneTimeCountryCode').updateValueAndValidity(); 
    }

    }

    responseSaveForD2cUser(){
        this.requestFormData['isD2CUser']=this.isD2CUser;
        if(this.isD2CUser){
            this.requestFormData['requestOrder']['tpDetails']={};
            this.requestFormData['requestOrder']['tpDetails']['name1']=  this.requestFormData['requestOrder']['oneTimeFirstName'];
            this.requestFormData['requestOrder']['tpDetails']['name2']= this.requestFormData['requestOrder']['oneTimeLastName'];
            this.requestFormData['requestOrder']['tpDetails']['contactEmail']= this.requestFormData['requestOrder']['oneTimeemail'];
            this.requestFormData['requestOrder']['tpDetails']['contactPhone']= this.requestFormData['requestOrder']['oneTimePhoneNumber'];
            this.requestFormData['requestOrder']['tpDetails']['street']= this.requestFormData['requestOrder']['oneTimeStreet'];
            this.requestFormData['requestOrder']['tpDetails']['city']= this.requestFormData['requestOrder']['oneTimeCity'];
            this.requestFormData['requestOrder']['tpDetails']['zipCode']= this.requestFormData['requestOrder']['oneTimePostalCode'];
            this.requestFormData['requestOrder']['tpDetails']['country']= this.requestFormData['requestOrder']['oneTimeCountryCode'];
            this.requestFormData['requestOrder']['tpDetails']['addressId']= this.tradeData.addressId;
        }
        delete this.requestFormData['requestOrder']['oneTimeFirstName'];
        delete this.requestFormData['requestOrder']['oneTimeLastName'];
        delete this.requestFormData['requestOrder']['oneTimeemail'];
        delete this.requestFormData['requestOrder']['oneTimePhoneNumber'];
        delete this.requestFormData['requestOrder']['oneTimeStreet'];
        delete this.requestFormData['requestOrder']['oneTimeCity'];
        delete this.requestFormData['requestOrder']['oneTimePostalCode'];
        delete this.requestFormData['requestOrder']['oneTimeCountryCode'];
    }
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/request-mgmt/create/request_add.component.ts